import { microTask as i } from "./index356.js";
function o() {
  let a = [], r = { addEventListener(e, t, s, n) {
    return e.addEventListener(t, s, n), r.add(() => e.removeEventListener(t, s, n));
  }, requestAnimationFrame(...e) {
    let t = requestAnimationFrame(...e);
    r.add(() => cancelAnimationFrame(t));
  }, nextFrame(...e) {
    r.requestAnimationFrame(() => {
      r.requestAnimationFrame(...e);
    });
  }, setTimeout(...e) {
    let t = setTimeout(...e);
    r.add(() => clearTimeout(t));
  }, microTask(...e) {
    let t = { current: !0 };
    return i(() => {
      t.current && e[0]();
    }), r.add(() => {
      t.current = !1;
    });
  }, style(e, t, s) {
    let n = e.style.getPropertyValue(t);
    return Object.assign(e.style, { [t]: s }), this.add(() => {
      Object.assign(e.style, { [t]: n });
    });
  }, group(e) {
    let t = o();
    return e(t), this.add(() => t.dispose());
  }, add(e) {
    return a.push(e), () => {
      let t = a.indexOf(e);
      if (t >= 0) for (let s of a.splice(t, 1)) s();
    };
  }, dispose() {
    for (let e of a.splice(0)) e();
  } };
  return r;
}
export {
  o as disposables
};
